import React from 'react';
import { Link2Icon } from 'lucide-react';

import { formatPlural } from 'utils/format';

import { useGuestSideSheetContext } from '../guestSideSheetContext';

export const GuestSideSheetDistrolistsSection = (): React.ReactNode => {
  const {
    guestData: { guest }
  } = useGuestSideSheetContext();
  const distrolists = guest.associatedDistrolists;
  if (!distrolists || distrolists.length < 1) return null;
  const isMultipleDistrolists = distrolists.length > 1;
  return (
    <div className="tw-flex tw-max-w-[95%] tw-flex-row tw-items-center">
      <Link2Icon size={16} />
      <p className="tw-m-0 tw-ml-2  tw-font-medium tw-text-dark-black">
        Linked to distrolist{formatPlural(isMultipleDistrolists)}:
      </p>

      {distrolists.map((distrolist, index) => {
        return (
          <p className="tw-mb-0 tw-text-dark-black " key={`${distrolist.name}-${index}`}>
            &nbsp;
            {distrolist.name}
            {index === distrolists.length - 1 ? '' : ', '}
          </p>
        );
      })}
    </div>
  );
};
